import { render } from "./_Cadastrar.vue?vue&type=template&id=376ce58a"
import script from "./_Cadastrar.vue?vue&type=script&lang=ts"
export * from "./_Cadastrar.vue?vue&type=script&lang=ts"
script.render = render

export default script